import api from './api';

export const employeeService = {
  // Get all employees
  getAll: async () => {
    const response = await api.get('/employees');
    return response.data;
  },

  // Get employee by ID
  getById: async (id) => {
    const response = await api.get(`/employees/${id}`);
    return response.data;
  },

  // Get employees by department
  getByDepartment: async (departmentId) => {
    const response = await api.get(`/employees/department/${departmentId}`);
    return response.data;
  },

  // Search employees
  search: async (query) => {
    const response = await api.get(`/employees/search?q=${encodeURIComponent(query)}`);
    return response.data;
  },

  // Create new employee
  create: async (employeeData) => {
    const response = await api.post('/employees', employeeData);
    return response.data;
  },

  // Update employee
  update: async (id, employeeData) => {
    const response = await api.put(`/employees/${id}`, employeeData);
    return response.data;
  },

  // Delete employee
  delete: async (id) => {
    await api.delete(`/employees/${id}`);
  }
};